import { DeliveryEta } from '@/types';
import { fetchDeliveryETA } from '@/utils/http/fetchDeliveryETA';
import { Thunk } from '@/redux/types';
import { CoreActionTypes, FetchDeliveryETAAction } from '../types';
import { getDeliveryEtaId } from '../utils/getDeliveryEtaId';

const isValidDateString = (dateString: string) => {
  return Boolean(dateString) && !Number.isNaN(new Date(dateString).getTime());
};

type PromisedDeliveryEta = Promise<DeliveryEta | void>;

const pendingRequests = new Map<string, PromisedDeliveryEta>();
export const fetchDeliveryEtaAction =
  (
    productTypeId: string,
    printTypeIds: string[]
  ): Thunk<PromisedDeliveryEta, FetchDeliveryETAAction> =>
  async (dispatch) => {
    const id = getDeliveryEtaId(productTypeId, printTypeIds);

    const pendingRequest = pendingRequests.get(id);
    if (pendingRequest) {
      return pendingRequest;
    }

    const newRequest = fetchDeliveryETA(productTypeId, printTypeIds).catch(() => {});
    pendingRequests.set(id, newRequest);
    const deliveryEta = await newRequest;
    pendingRequests.delete(id);

    // check if it is a valid response by testing for one property
    if (deliveryEta && isValidDateString(deliveryEta.earliestDateUTC)) {
      dispatch({
        type: CoreActionTypes.DELIVERY_ETA_FETCH,
        id,
        payload: deliveryEta,
      });

      return deliveryEta;
    }
  };
